(function ($) {
  $(".column-slider__items").slick({
    autoplay: false,
    speed: 300,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: true,
  });
})(jQuery);
